// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'is-style-img-oversize';
const slidableBreakpoint = '992px';

// ------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class imageContainerOversize {
  constructor(el) {
    this.el = el;
    this.element = $(el);
    this.img = $(el).find('img');
    this.imgHeightAttr = $(el).find('img').attr('height');
    this.imgHeight = $(el).find('img').height();

    this.mediaMatcher = window.matchMedia(`(max-width: ${slidableBreakpoint})`);

    if (!this.mediaMatcher.matches) {
      setTimeout(() => {
        this.setImgHeight(el);
      }, 250)
    }

    this.mediaMatcher.addEventListener('change', (event) => {
      if (!event.matches) {
        setTimeout(() => {
          this.setImgHeight(el);
        }, 250);
      }
    });

    function checkForWindowResize() {
      if (window.innerWidth > 992) {
        setTimeout(() => {
          let currentImgHeight = this.imgHeightAttr;
          let getSectionHeight = $(el).closest('.content-section')

          if (currentImgHeight > this.imgHeight) {
            currentImgHeight = this.imgHeight;
          }

          if (currentImgHeight > getSectionHeight.height()) {
            this.img.css('max-height', `${currentImgHeight}px`);
            getSectionHeight.css('--section-min-height', `${currentImgHeight}px`)
          }
        },250);
      }
    }

    window.addEventListener('resize', checkForWindowResize);
  }

  setImgHeight(el) {
    let currentImgHeight = this.imgHeightAttr;
    let getSectionHeight = $(el).closest('.content-section')

    if (currentImgHeight > this.imgHeight) {
      currentImgHeight = this.imgHeight;
    }

    if (currentImgHeight > getSectionHeight.height()) {
      this.img.css('max-height', `${currentImgHeight}px`);

      if (getSectionHeight.hasClass('constent-section--distance-none')) {
        getSectionHeight.css('--section-min-height', `${currentImgHeight}px`);
      } else {
        currentImgHeight = (parseFloat(currentImgHeight));
        getSectionHeight.css('--section-min-height', `${currentImgHeight}px`);
      }
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new imageContainerOversize(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
